import {Shader} from '../../index.js';

/**
 * Static Hypercube.js depth shader sources.
 * @example
 * const sourcefragment = ShaderDepth.sourcefragment;
 * const sourcevertex = ShaderDepth.sourcevertex;
 */
class ShaderDepth extends Shader {

    /**
     * Stores the attributes needed by the shader program.
     * @type {Object<string, string>}
     * @public
     * @readonly
     * @static
     */
    static attributes = {

        'POSITION': 'vec3'
    };

    /**
     * Stores the fragment shader source.
     * @type {string}
     * @public
     * @readonly
     * @static
     */
    static sourcefragment = (

        'precision highp float;' +

        'varying vec3 v_color;' +

        'void main(void) {' +

            'gl_FragColor = vec4(v_color, 1.0);' +
        '}'
    );

    /**
     * Stores the vertex shader source.
     * @type {string}
     * @public
     * @readonly
     * @static
     */
    static sourcevertex = (

        'attribute vec3 POSITION;' +

        'uniform mat4 projection;' +
        'uniform mat4 transformation;' +
        'uniform mat4 view;' +

        'varying vec3 v_color;' +

        'void main(void) {' +

            'gl_Position = projection * view * transformation * vec4(POSITION, 1.0);' +

            'v_color = vec3(gl_Position.z, 0.0, 0.0);' +
        '}'
    );

    /**
     * Stores the uniforms needed by the shader program.
     * @type {Object<string, string>}
     * @public
     * @readonly
     * @static
     */
    static uniforms = {

        'projection': 'mat4',
        'transformation': 'mat4',
        'view': 'mat4'
    };
}

export {

    ShaderDepth
};

export default ShaderDepth;
